var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgM1Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "#28C76F",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.76326 5.72063H9.35242L9.35106 3.43708C9.35106 3.19589 9.15415 3 8.91193 3C8.72729 3 8.56955 3.11447 8.50483 3.27561H6.62367C6.57223 3.27561 6.52488 3.3049 6.50172 3.35089C6.47855 3.39688 6.48366 3.45208 6.51432 3.49329L6.99841 4.14057L6.51432 4.78784C6.48332 4.82907 6.47855 4.88426 6.50172 4.93024C6.52488 4.97623 6.57189 5.00553 6.62367 5.00553H8.47177L8.47109 5.72026H7.71855C7.64326 5.72026 7.58228 5.78124 7.58228 5.85652V6.88265H6.21925C6.14397 6.88265 6.08299 6.94363 6.08299 7.01892V8.16802H4.71996C4.64467 8.16802 4.58369 8.229 4.58369 8.30429V9.34368H3.35697C3.28168 9.34368 3.2207 9.40466 3.2207 9.47995V10.7674C3.2207 10.8427 3.28168 10.9036 3.35697 10.9036H9.76292C9.83821 10.9036 9.89919 10.8427 9.89919 10.7674L9.89953 5.85692C9.89953 5.78163 9.83855 5.72063 9.76326 5.72063ZM6.89584 4.73339L7.27807 4.22238C7.31418 4.17401 7.31418 4.10758 7.27807 4.0592L6.89584 3.54819H8.47314L8.47246 4.73375H6.8962L6.89584 4.73339ZM8.74568 3.43717C8.74568 3.34654 8.82029 3.27262 8.91192 3.27262C9.00357 3.27262 9.07851 3.34655 9.07851 3.43717L9.07988 5.72071H8.74397L8.74568 3.43717ZM9.62695 10.6311H3.49354V9.61619H4.72026C4.79554 9.61619 4.85652 9.55521 4.85652 9.47992V8.44054H6.21955C6.29484 8.44054 6.35582 8.37956 6.35582 8.30427V7.15517H7.71885C7.79414 7.15517 7.85512 7.09419 7.85512 7.0189V5.99277H9.62691L9.62695 10.6311Z",
    fill: "#20E290"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgM1Icon);
export default __webpack_public_path__ + "static/media/m1_icon.3a39be099561ac724fd2c9518f434bea.svg";
export { ForwardRef as ReactComponent };